export const leaders =[
['0x6b22e1ac6940d2832607648fff3d7ca8a5224ba6', 1711],
['0x39c0282ee43fba5a91e0397e88add395e5e9f3fa', 1544],
['0x38444084f5df238787f9094a61c5988442c09077', 1435],
['0x8c695d728b426e7a16052e32e8ca72777ed51fbf', 1428],
['0x3d7280047ff3c3937414f29debc7ae203240c22d', 1361],
['0xd1e76a69637f73f186e2b27ee7abe39c00393113', 1361],
['0xb38d67283989c35317c64cfafa901a36d722a271', 1167],
['0x34f9cadaa1d9ce3ec7194137cf5d2cb1fe1ea198', 1151],
['0x2bb49f11131f5537f46cb356a1bf93a8169a2720', 1116],
['0xe7f969671f7dd4f37fb2b0548041e2fd3569d228', 1103],
['0x6ddd6d3408c2ddb8064c034350ba3dc9e658bdbc', 1083],
['0xf1db24850684eb675f30013d82d5c0ed030b5634', 1050],
['0x5d02c857e98465f5b3a957b1f43569c4dae58ca0', 943],
['0x0db0960e1e358875c5a39a2422425a8513dd77ae', 916],
['0xcef00595a2377e2239524106e6117c8599ac6455', 891],
['0xb64c2e41ad313d25ce643a58b876fbe87427f96a', 889],
['0xc9673d68c30d0beb6d11a8112cdf00bc6eccb98f', 851],
['0xf9a353c8c1259a2556698e91877f2d597b1454a8', 812],
['0x3da2b5a4838ea10b9870a65a1571da989a519079', 795],
['0xea38c3f8a58d05f890848efcb4a22678c78e00ad', 790],
['0x90f70aafb542dde87a0d8f429a6852632eba3e89', 769],
['0x492dcea5f6a71e74375b91ae474521a353d8348a', 699],
['0xf923560ef6d74d310534fb45ae2226a8ea325b03', 689],
['0x8774a4e5f0f753a19dea902326c58c56dc6e33e1', 667],
['0x902116316d1bfc0c7f4a6a412578770eb215efd0', 647],
['0x2461eafb9c4d9942c989e41e5036a8808f86eabb', 635],
['0x0d284265b8682afea68f2ae9cec4e014fde7006d', 626],
['0xe2385468c4ff3263951d9c584174614a4abcd0a9', 626],
['0x1563c4751ad2be48fd17464b73585b6ba8b6a5f0', 579],
['0xbaf88181a1c74d1fea19a6313c0d3de73c4c260f', 537],
['0xe1337d40a2fdf07f75fbee336204b89f5b31e525', 527],
['0x82c854504f266dad4a7ea9e448ca7b1572aebf1c', 519],
['0x1063d7f8225f69698637f7fefc3a339a1eb21cf0', 495],
['0xeab8e50f305c3b97aa5eb818e09a59124c357b91', 489],
['0x42a1ef5ffdaf134eb958814e443db9c244375c8f', 474],
['0xb31f7728aec8edb9dc68f3a84947684fec33a4fc', 465],
['0x4d4a6aff095f40070a072fc877d9293d1341e628', 446],
['0x33cf9d8e8467d9fd13a0fb4e64423d06bc5f2524', 435],
['0x630204233b046f477a4b0faec1d14e9f637e3773', 423],
['0x5e92f2482778bb2faa122f3de6137790469d78ff', 421],
['0x8037ccebebb5af26459d6ef3aa974e2d65fb7c05', 403],
['0x632027d15cd8e6d97991771bf0d6a01b63b16c81', 396],
['0x411258961fb281192da51cccb65732f967d3a2e5', 395],
['0xcb0ff126ed01183c1cc45ddc3798e5f923cf3abe', 392],
['0xe716bc88a611a481750663d7e4fcfe60c2f6fe6f', 392],
['0xe03a07aa1010549d74adf04a94b04d74e5a48aa0', 392],
['0x316602445edb542798a4ebd470f3f57fb8641e77', 376],
['0xd4b2905ee116d13664840f67c9374b768d1297ed', 371],
['0xb2a03b41c7e06512fbb852443a143c664bb339e7', 363],
['0xb0ba26dedc9c1ddae319de606c3b1279e26be57e', 359],
['0xaee8212c786c724d5682735d906a7b1e459fef3f', 357],
['0xeda5942831bd8b391c52fd7896a123e9d2add51a', 352],
['0xb8d86d6db117e21c27636034d3dd8859018daf9c', 349],
['0xabbf75a59ac8838fa46bd5260501b68ab28b95f6', 349],
['0x97e24810ae6914d29d89e79ce3e663d83f20d0bb', 348],
['0x9f1031df92c7bd2a082d16a47a020f637bc4969b', 319],
['0x579c0c05b15e9268e33f00a49aec8b7cdb8c4f27', 318],
['0xf947c3c9ada5ca0995d56802bc8a21c5e8e523dd', 314],
['0x2d19624dd8bc9bdb4ae1460cf0f9d6d3a2b04199', 303],
['0x7ad6f107e816dac44cf7a823f0b7b292a56a1723', 295],
['0xcdc7b771a0ef67519cfeba630451bfe1736ef344', 289],
['0x6d1e0084a6910a8803ab7c22483a1a2db3f1001a', 286],
['0x220faf934025b7824af72bd6f27153b0f01f2364', 279],
['0xaccf339e9985ee2984aef6ba0b4605bea3d3fd88', 255],
['0x72f4e8b893527e3884bb4ac5a28d5fc65172ec4a', 253],
['0xafafcb552bfd919d5a6bfdb8af0c7a72e36dfdee', 214],
['0xb4bd807c9cdde19ae1498c7b7006713268e25997', 213],
['0xdf9e2288b48176b1f4b12548815decc09e9f2f79', 201],
['0x73b1b3410ac9c28216a0012aedc6926436518f50', 180],
['0x883ce32e186c69559e94c8ba276bfc4322fc194a', 174],
['0x8de3c3891268502f77db7e876d727257dec0f852', 171],
['0x2cb6e9cca295dbca5dff141028e8fe1dee28e700', 164],
['0xb69d4bb72c67b218bf1ee3de9f2cd60e223bbaa9', 164],
['0x7d828b25640079d2461fde495f4b129c86abce12', 163],
['0x27d83f1308665e2be54faebc11a53457f85fa016', 161],
['0x656a41eebec46a6f3709783c8c93c2e522d2afeb', 160],
['0xed8e924735f590572361b52657abd9a3260f35a0', 158],
['0x2cd170d34740d2356c464f6bffec1d727a6c96e5', 157],
['0xbefd65b66b7c314747b3146c2e0998f4b151ae7f', 155],
['0x583ca46d558bb5011171eb71c6a63eafaa266e8b', 149],
['0xeaf9a74ba2928a903366bd42339f1bbf1cbdaa59', 137],
['0x199745e7b4efead0b2f027e3c3c88b1c77b3b780', 135],
['0xb35b15694f5a9966db6c028636d4420c3113b398', 135],
['0xd17a3afee8e657b837d858e99a462f7027636e3e', 132],
['0x22e0175c9ddc50e0e66753a0537f4029cfcbb1e7', 129],
['0x68aedee7dc9da33a1e7d32a6637361e409c40519', 126],
['0x5c803ee6f40dfded2923277a8053a28eee43bd82', 123],
['0x34b3ea1e864c82912765255306ebb9f140fcf0f5', 123],
['0x1e6cb6a6d61c35183f0e1ac8bfea847a3752b3e1', 121],
['0x2800d8f97d54b283f782db3b005ad8333c166b39', 120],
['0xeb6eb2b7d5bfcd2550b2200dbd2857379e5cd00d', 120],
['0xf244b3050ec606ccdc1edbce534a2343fe3e929a', 118],
['0x19a5b87d6f61893ffbbaff650029f6d505afa920', 117],
['0x0df770278ddb5856205bfd456b61aff680eb7b6c', 115],
['0x7ad92e2b66c772ca9c56d4b59660ed537b28ab90', 113],
['0x61125f52cee83ed5d7a6cd14598d34974b11865e', 112],
['0x69e23912728d62bcd2640d96fbdf06767eb2d67e', 110],
['0x823b6b8da270906f0a231223e46edb5bdea3ff13', 108],
['0x189589abc6794f1c9b385099849c49598e987a68', 107],
['0x8eb9da111684294f6d57c8c400c71d33e1221800', 103],
['0x51a1476c2c4bc15b72a705b734a2ac0a9e99e71a', 101],
['0x9e138c3c1249f1627168d02359a4ba82e5f2ebd4', 101],
['0x8b6b7cd9cf40d1561532b7bc9643d12139a45f8d', 99],
['0xcad386d2c10e2b588db4e756b99380cbfe36885c', 94],
['0xe06d67e2cd5c51cbe0ec603a1e314039875e0ab2', 92],
['0x2684d73ca86638f656eb6f98f725fe317076d99c', 92],
['0xa16dd5dc89d9e36524e3b75de78515ed7ca4f1fd', 91],
['0xc96a2dc16d2231fa0c8b572f2bf34d9cbfeb8ca6', 89],
['0x265f5a9b3181ef516d755cb890a24a98e7d641ce', 87],
['0x11da8f19361fc815074f1f86f4a9216984070b99', 86],
['0x98bd996e969ab447d85414a8bec45e3e85fb0776', 81],
['0x9a2a659980a8fd84790b456696000c8eba9bc578', 80],
['0x302d7125e4974ea52f85938cf2bf62844cbef510', 78],
['0x97db0e57b1c315a08cc889ed405adb100d7f137d', 76],
['0xe8d00e3bc224d9f55c70325634f37a161e45eeda', 76],
['0xa380dace2095adc258d2be066e2a60a9dbacf7ad', 75],
['0x75405db3efddc536bdaff015782b81eedf3e900a', 74],
['0x11584d6aaebfdbf48cd5a11599bf40b5bc386837', 72],
['0xb2085ae494577852a35bd836459da149780130fe', 71],
['0xa6b6d854e4e5f2b36e51d1dff81cad56e5f286c1', 69],
['0xda6a10b3bfd88c8658c6edb94ca1fd6dea62889c', 65],
['0x21f6f0f810f07fc9e13fee89fdcbc0362c47edc2', 64],
['0x38dc04ec68ab54092d2a5ba01fcdd288f8a83107', 63],
['0x9b4b12d5ad108830dec7911e262023f372bdda75', 62],
['0xde8476883a4b9acefcf736a8f97bce1f1fb54b37', 62],
['0xb1d009a27f194ad430430469c27aadfea7a0bd6b', 60],
['0xb40488bbde7c183c8ef9d6ba4a8682662d1d0b0d', 60],
['0x03f1a715650814e31eeea113b3145981071dbfbc', 59],
['0x86575e8371bb8270173670d0e045e64f073936d8', 58],
['0xe5845761e7773976055f2559ca54be41f09d9e88', 57],
['0xbfe709589e8fde046fc6d60edbd2bce1299e76a9', 54],
['0x919dc858c9f7c8ff5026da39668454f240282d8b', 54],
['0x242d96508bf41e152739280a822d707d99c9b876', 53],
['0x30e12c32dd4ac3ac28122990fc43e36e74f77515', 53],
['0x6c0d470d97ef1f230eef10a5c848afcc8261ed67', 50],
['0x1363150a96ce368838bff7f7a4b399811ab1a7a3', 50],
['0x9aab7069ac7c9447cbca511f448b36c04be5476e', 50],
['0xdc556cb123db4172fdb0dc8c95bc0a7132b9487d', 50],
['0xfee03b642100b9d5b1beb5a9f5c1db190d6837aa', 50],
['0xa89f7a583f477212f99d34ca1d379c934831a210', 50],
['0x6c3ad0aec8e8b9aa3a58c839e0f5f0ace1fff981', 50],
['0x722d97398ed670be033e3a435d590e82ba50a72c', 50],
['0xa9b815846d364cdf54e5cead6b6e199d77aeef13', 50],
['0x64acef3297972c9bfed88af18926ffb639ce0ab3', 50],
['0x08e0ab9353d1d19813719cd68c3454cdc66898dd', 49],
['0xd57497aed2324517f801b5cf8269edf996907a82', 48],
['0x895561a75dcefcac3a35488bbf7b2bbca950e5a6', 48],
['0x9db66d15e466b4eab2e33b690569eaf50fd99f92', 47],
['0x438f57868f7499054f392a8676ceb8dbeed6d433', 46],
['0x44e434b0eb83534b697f9c77ef11fb981b637def', 45],
['0x9f245aafa4902a2aa9e09cacbf5684e6c4580a8b', 45],
['0xda944123a5f5e970f9d6f9c21c54968c87de6d0b', 44],
['0x5b3067c5e26fec823d6fbf8f315e43632658d2f6', 44],
['0x36d481b3c6ceca782b1fe72a80d704da06e6c063', 43],
['0x824deaeded54d64671b502ade5d23cb83d4661cf', 42],
['0xc7450a7c19c366c283d21ba362b3eb7ccb8cb07e', 41],
['0x01223843daba104d5cfc48006a8f22e777148971', 40],
['0xf0b9aa2a5b8e6ce7b18b3c832cec1d742848f115', 39],
['0x09d6679f6913b32ccf0cd3803e688a3a496452d7', 39],
['0xa2f7ee60f19be79f53f8ac28badfe5081642bfee', 39],
['0x6cb2fc304d504acc815203b3009cbf4dbc21985a', 39],
['0x9fd634393707ad07739d63c81011ba067681a19a', 39],
['0x907f11655ae7a436923b7949341c65a8213ab250', 38],
['0x87d9fdf0ef434c581cd4a410df6fd736349faa4b', 38],
['0x67ed35ed9d3bbb0b82596f4e0e07499a87aac518', 38],
['0xb1f87f5fb92f4005be79945e33bd2d5faa2c01fc', 38],
['0xe164f3ace64c4e02ecbd4a7625d1c928afac7491', 37],
['0x5d0b9beb7a0853ca712985c26939d023fa7065aa', 37],
['0x218aebe8440674a0d6e4a9ee18154a2da645b163', 37],
['0xe14f785b0f71900b1a02f9c26be44a0e21990afa', 36],
['0x4a979113727bc341e741d4bd966009d34c2fda92', 35],
['0x4dffd217f4951af952577888036b084bb3f6a596', 35],
['0x9015cfe99fee5a2f5a01c2c6b89393bb166d6dbb', 35],
['0x234356a188694abff3a23261fe66231391ce1d44', 34],
['0xf89e2e88835481ade9826e032478762130695494', 33],
['0x8703cb33299449766a8390fb98122ab6d0619c0c', 32],
['0x128fe2989e1827d16bd9ccfdfd107f937f0095a8', 31],
['0xc0a1162c3ff721daa7e0141eb639cfb5765ea589', 30],
['0x0d570e65873f012f0437864abb4ea9e3ddc6d87b', 30],
['0xcaf58bbbadc001c5696e0da0313a47cf6b946d6f', 30],
['0xac93d32ff9f280b2b65b07ce73ed0cc4bf774d82', 29],
['0xdd86477903089c74e9c8921d180483fea0c83bdc', 29],
['0xc89da7f8c6e075a59ec631d8ae933073fe0e620a', 29],
['0x0bc93dcce6397568e291d5a2bc4751f507a541c8', 27],
['0x77c681753979400dc7310b770e88d9c823d1d808', 27],
['0x551e3bf27c5bcad1ee37dc1a76b108c509d97d36', 27],
['0x043cf0414ad2991e910e464e4f3e80f14d7cf0b9', 26],
['0x2e918a8529e58494ff1bc6a63d9a425e113044c3', 26],
['0x516649dbd606a980e767bdedbcd882d91c859c9c', 25],
['0x91ddeb35264287785762e666b5fba5da9e83b5c8', 25],
['0xc9eebecb1d0aff4fb2b9978516e075a33639892c', 23],
['0x7f76d15c57df1a4a6a9b92a22bcb67b19ec20231', 23],
['0x05a3a14b4c179b9a3a3f3a8933853f95dd87b9ea', 22],
['0x15b7d2c57190d9ff71244a38df129616323f3f25', 22],
['0xd88cff1d9f7e0e511ca50f6f169c03354b384135', 21],
['0xe19763baa197e17a5663f8941177bfbbd31a7ab0', 21],
['0x0d4ef08ce3fb54a27125357b9796f7a8ae092573', 21],
['0xa4e5a0f0472071bbf2c766ee823ac46a5337a1c3', 21],
['0x7a25e9bc4774d94dd310185700c429c42d25a069', 21],
['0xe1f565b74de13bf83ba6b79a6b492b89ce9fea91', 19],
['0x6c28570747e25f2935902cdcce9f22895764cdc2', 19],
['0xd0cc64e36bea20103f4bbee5b8c1a1436b2e0110', 19],
['0xe45ae2fc6f28c7b0b8aba6f844f95d6b052c7dee', 18],
['0x39129dcdc2f836653b6391edd991be4f4b675c8d', 18],
['0x5ebf21454f82298ccf92eb6e2d3ffaa383a72176', 18],
['0x4976d2d3122c5d9392237efc1c1010bb2efddb81', 17],
['0xbe72d4a70c047adc435be93b7e8ccde6fe431f58', 17],
['0xf2e4a05cbae83fb3173becee7a31686e8a6ae3ce', 17],
['0x5763507aa0f014b4153abc71108d1797ff17664e', 16],
['0x729f6d2383f5178ae1a76b45b8b69c7983b53aa0', 16],
['0x01f109ac6e947715b3c3c506ee60d324d45edcd3', 16],
['0xcd0f8ad65a92428b9ecebda3141833e79ff0f6d9', 16],
['0xd9010fb0b7df8bd85b7b614c01df9a65e032f60d', 15],
['0xb2c1119c4ae30ce46af14b67131e2277aab89d88', 15],
['0xa8af39a6e036ec312d288a181c8ee5939162a1dc', 15],
['0x17beb6122bc0e2b3199572ab662db0e3860323bd', 14],
['0x50d398268762dd37b5b5acba486b9aedd8f6d8ce', 14],
['0x27b0b4033b6bdcdf12c8d4b86969e3aee53ca107', 14],
['0x499654b8d5ba3d318fc80ad478d28ca3530e4c65', 14],
['0xda4bcd3ed7c54bbedca1012bdf9999140b9ec840', 14],
['0x7e639a0879ef119fd6a392ce78a029e88699f07c', 14],
['0x1016112b289bcd8fd00d11391e797fddb379ce2f', 13],
['0xb2ae7773e14d857d1202cfc2a6a5a2a3de1525f5', 13],
['0xc44079e445f0dfe2385c523bc6011292f2fa26df', 13],
['0xcef1d967d02ebbd6c4d34ab2136847ee25ca7df6', 13],
['0x9328cb6133a7d7a45452e984ec7b0c0c1f000852', 12],
['0xa85d48fb167743e1518ac8c6045678e1dcffe623', 12],
['0xcad0a207c41399d0c8d4d57101985f47fa9e5903', 12],
['0x287074d5780dcb5fdb084bf99676079f308a5f3b', 11],
['0x8363530368d284f39100802c9eda277f86ec6904', 11],
['0xb0fabe3bcac50f065dbf68c0b271118ddc005402', 11],
['0xa9e3c85208250d97fed0b8ed1c659e5bed8442f1', 11],
['0x9950dd62617f6123551aa61de4a31a0dee02a4e9', 11],
['0x4533e03d983fae04741131c5f7cb35f1b32a1acd', 11],
['0xef262cdb9dc8280ab40b30120180aeb73c939df7', 11],
['0x2a59d6b103a2ac8dda003c2d21317670db624d52', 11],
['0x25954b95ea02df586e07688de9543eea5bae31d7', 11],
['0xf73bd5710d3e3d4e8db7ec6058f9fb77ff8414e9', 10],
['0xd71d837b8ce264e9a24acf9cdaeed32628acfcc0', 10],
['0xc29dac18bf481c1615caebea293b84c15b383828', 10],
['0xc52d4727e972c305c9a865a86f291674ccbf03be', 10],
['0xfba3854b914a566ec8929c6b0535543cc13481e4', 10],
['0x22e916361cf092c02a12ffc57a55447ee1a6da3f', 9],
['0xedc9676082821f370a3d863ea3d4e0c06bae6b9d', 9],
['0xa6861734e12e45e3b3a1dfc3d06d1bc5d3c34589', 9],
['0xf5fcaae203bd5dd81ef969c3fecc872f38aeccab', 9],
['0x19246d4cb92671d0f2166d00c9de687ead3206f8', 9],
['0x15fab1cc5262d69853b1196f74d38c7fc96fc6d7', 9],
['0x4ec616f2a7a55d93941330709b32e959bdaf9ebf', 9],
['0x2fe9811e6b3cceb5c14cca6523f10ffdf4288af6', 8],
['0x540f3bf895ff2d10db9d9fdf5cd39c8313fd8d6c', 8],
['0x5417a03667abb6a059b3f174c1f67b1e83753046', 8],
['0xde6d59a1bac947ca7d320859c8354b42d521cc87', 8],
['0x0282e055d3b2f7c0ad656952ac1bb989fb6d0086', 8],
['0xe9b1069573af009357c26d35cdd04bf4cb1d9c9f', 8],
['0xaf7706e18abd8af56b1b9fd4d02af130e0d36d53', 8],
['0xf58764c35ed1528ec78df18bebb24fa20f6a626f', 8],
['0x839a4547fb3aef7c68bfc28248f7fd1de952b524', 8],
['0x8ce2b1348740d27d6075f602ad679a041407fdec', 8],
['0xb229b304cee3ba4858972d13735fac16c6b8347d', 7],
['0xc0ded526a536f24bca0bac704f3a9247188aa506', 7],
['0x9d2699358b4111eb4f8a2901d2f68c3c0cb2aeae', 7],
['0xb86b5568853c5963dd9b9836f5ec94a15966bbc9', 7],
['0xea869669210a69b035b382e0f2a498b87dc6a45c', 7],
['0x9809675e4dad5fae3bd8145a92a9fb49f4684c45', 7],
['0x19739686960105e8f2f34f7d6537da651ad19157', 7],
['0xa91792b5f297148f89baf4fed67f647122ea833f', 7],
['0xe53439db3e9a240c5a8b5abb874bbbed5934c47c', 7],
['0x69a00fafe7e935fde9ecb5c53f23e0e409a33e12', 7],
['0xc041d3e4b12b163cb3570daa0f9192d6245fe35f', 7],
['0x11706cbdc8f11e63a0230e503658d63fd6b1b688', 7],
['0xb495023d8eb9526d8ec346703f2cff12f2a6963d', 6],
['0xe9aa3a5b4ee5b3f007cb736dafaae430a2043e51', 6],
['0x9c0c06c6213498db58550c05c36879c620b3d26c', 6],
['0x8235dab40a8564289738719b94a9d4d31efd53d3', 6],
['0x55a3aa5a7ecb1c5c738b097e67efe6a0c1be935a', 6],
['0x213fa1d4ef939f94cc4d659ed32fbf0a3e8a4e7a', 6],
['0x9b493ebb7927129401c13573e4c89afa73905df9', 6],
['0xd95cab8914f30961f50bdf3d84d1605287578506', 6],
['0xffe3385962b6bf54860f06dd35d5db3504bd1286', 5],
['0x190df206d103b3edde9db6be2bd3ea54752d97dc', 5],
['0x0e1ca0c78c85457e04dd6f256b290f6c31b7629a', 5],
['0x2f881add600ee31552eeca0ac770cae3e0b2f137', 5],
['0x752d5a59d9cd3ed8af87e0c8939d5d19db168331', 5],
['0x548d3b9d71c319a5e7b46fd5671e54da01c0982c', 5],
['0x0e6e7cb30770e922bd85ccbee6edb4843c3aca3c', 5],
['0xe8fecebac598ada02f93ccd8a25cff79835efe43', 5],
['0xe5bc5612bd5d5dbf0c01a0b33bbe6ff36d9086b9', 5],
['0x178f300c7436bfd62ef89eca8933bc8f257a5d0d', 5],
['0x9ab6f1202e39d65b8b4192445a714ee39ae203b1', 5],
['0xfc8084cf7e0f916f114f9bdd8a86ba2427efe976', 5],
['0x284073bbdd7d44c697fd793f66c4b0270af78920', 4],
['0x672fd76b1d6c6287c3dbca06506552ab4f113c43', 4],
['0x5f57ec03370cd600294b77025020c464daf31640', 4],
['0xc0b8b7fb5e4a77044d647a2bff871ef236f0916e', 4],
['0x258754bbd8a9a46454da4716e15e8988c905f50f', 4],
['0x860cd5bfb75bbaa752bf597e4d023e1e0061365f', 4],
['0xd1b62db7ad09e615a4603e89c2f25fe8ad67e596', 4],
['0x8445901c0cfbed52045d8acbcbacc1f0ed65a8f5', 4],
['0x0c843ddf7c5af97b29f0485e5011f0a86530d9cf', 4],
['0xd22139cb7a7633c82e343fe4ff5490a965e6c1dc', 4],
['0x008784ca66f5f469dfd2cfcb42a29765dcae8de4', 4],
['0xdb4084237cc26f849a067e30bec92eef939d7378', 4],
['0x3f2e7c43c44018ea1c148eda541ccdfd923ee18a', 4],
['0x5f45bdf46d2099380ceb221e2e41a3704523f048', 4],
['0x34ff2380ba7822c932453142b16fd87db1cfe4e0', 4],
['0x728eeae5351b17916ce7724e6d316a3a80e10a43', 4],
['0x94d8304478550db42bdd80e16f75bd4d3420a94d', 3],
['0x052e323e1e82ce20cd92657ef84d2abea8354af3', 3],
['0xa7eef766b1f3f3d31a0c7c6ebd0b3f31e9a87634', 3],
['0x8288090f6016bd90dc234fc619baeaa6ba031ba6', 3],
['0xfcf81069eabdf98ce02c9fc3510e5c64135772ef', 3],
['0xafe2250b60afaa033c8949f2f5c7c915ef8b49e6', 3],
['0x11a15c04817042dbb738a58150f341331f7265b0', 3],
['0xea4c9f20217a173a675dd61771dd92f63c63dc36', 3],
['0x5882aa5d97391af0889dd4d16c3194e96a7abe00', 3],
['0x4a186a59938d5c8cea23b47e096a2e1493e8dc76', 3],
['0x92425329401f8b1e7884be195784daf12ecbf297', 3],
['0x77d75c135087f34dbf27238a081551725ba796ae', 3],
['0x67dae9571396b01743c6c93e9f62527134117355', 3],
['0x2fa85587de409ebc62b8f6d2b4e2f23d5b425390', 3],
['0x550129cd7f7bb0e6db429f8ac0b70a073669e198', 3],
['0x25be2281deb6b7e54b90e2e1e0e08c5f91a9d9b7', 3],
['0x21dc435196412b8bfe369c14e5dec8d117ddcc47', 3],
['0x610b6d8553fc2c536e1ebefebf691b94d4e3d4db', 3],
['0x6f2affe6abf7721b50c4ee64082a20a28d6ab8ca', 3],
['0x2e7f51b80b51046fafd038c495394463e5b0af0a', 3],
['0x47c8260e5279495a9307ac7481eaa9ff977a02e0', 3],
['0x7ca272a70fca0faa957b801ae6a5ca728912e6e1', 3],
['0x00e81d0d81012e24a8c39aea69a9816c85409201', 3],
['0x14ce79a0463be6e9ff38aa086a8b3b90e635e235', 2],
['0xb946795a5cebb3f252f7ae7d38ff83b9ad3031d0', 2],
['0xfe7c2b6ce4b61ac06c83637154e4ea05f665b5fb', 2],
['0x7404aab275b3d2d2404e00e650c25f995fa43876', 2],
['0xdb7b6dfd744b775dcf987e3b584516d429d3063f', 2],
['0xa28d31dec6659b8011e15c34cfb40cb72f718ff1', 2],
['0xe97cddb38bdbbc0c9e85982b19489f9f96630bca', 2],
['0x5d4df680d2aec9d745dd7dca1b28aad765e36ca6', 2],
['0x0f4cbe532e34e4dfcb648adf145010b38ed5e8e8', 2],
['0x51616b471089cdc15b51f5b2c592e4cce98297f9', 2],
['0x1047642e7d07565a8411023feb067a652d507edd', 2],
['0x9b2a08ea17e5b855fc2aaa79ebdbee74f1e15bcd', 2],
['0x6bb0e66b437e4e1a61a86a729ce359eee686d811', 2],
['0x399bbb19926274cd757771b9953e26908b2f2048', 2],
['0xf8ba19ba6505d54cf048c8676886b2002127d454', 2],
['0xfcd3a9d877face26343a34eb6f402f747f8987ec', 2],
['0x61560578483faaffa3c8db1b0f4ad675ed1068e1', 2],
['0x2bdb33deb050e499bc90afb9bf2399c33e3b9d39', 2],
['0x7a60e44ad43c78eff40c015d634db2aa95d51d07', 2],
['0x07032a5ef16599bae7b88e7837b17ce00ead9553', 2],
['0xc78e8ea590c6c75c346fe8c7b1ef302cffb9af0a', 2],
['0xcfcc136f40ae2cc2711cb3ff607384474d635f46', 2],
['0x81b4c439978275eb2fc8c3a6c81cd5a10c68c050', 2],
['0x63e6e54e39373d74260c48af537fa4a9a4c95506', 2],
['0x29c5fbce55fc9a38c6e7b1e4351dba1563a835bf', 2],
['0xcd00ba27c68cc8ae8ffe57673156bacaa383a4b5', 2],
['0xa9a43ea2c1a259dee4b53b6dc5d31fde60531830', 2],
['0xb11766a8c7329bdcbae6bf833b578559d385d37b', 2],
['0x13115f11db9c5900bdc43dcff0f90fdd151c4282', 2],
['0x49a7de07d0051961abf7e3d30aabcc4d42716586', 2],
['0x2d2dae07a429694f49ba6db61016e5e92b6e4240', 2],
['0x758fe7e0d53d46a97801e63abea0f78c2ab73055', 2],
['0x9c6fb33fdbce49c9f95bc7fb7722dcec9cb5ace1', 2],
['0xbb12c5453375332107b24914d169b6ac99bdea8b', 2],
['0xd40dcf6788bc8d84835f6653124029bade1ca894', 2],
['0x4deaae930ae5251d28e500b2372c626088c85ce7', 1],
['0xb1fc41cbad16cafdfc2ed196c7fe515dfb6a1577', 1],
['0xa64245f5e6ed5a0c32f2f147908b8e55259415ea', 1],
['0x50e2d70eab4fa0caac04c1aec62d8917cefd6cac', 1],
['0xda844c856a99d1800a48a0a63f191732b41d5170', 1],
['0x529074765b378692cb90fc60901ad702cdbc0fdc', 1],
['0x8c2205e0fe3725666646d8b2b91e8d1bddcc6bf5', 1],
['0x326a99047a5e8e687812c8455bedf45026ed63af', 1],
['0x4814b217308ed522acb85a679291417cffabfb67', 1],
['0xc3660ee9c357bf631af63621385dcf9d5cf2f301', 1],
['0x97f7beb12bfb27eeb01f6159c4e05439dc9f1b75', 1],
['0x3187caca785a96da5fdba77acd3e665e9f0fe0bd', 1],
['0xcfd8692095fee489553758382db1b354d60a5cc2', 1],
['0x5685a0d411e88fdf99702189506540807c0fd4f0', 1],
['0xf4a680bdcced645d62e6265ff6e3240777f2f364', 1],
['0x5368e0e3761d6123545c21c2073661a153c060a2', 1],
['0x98ea68cdafd3fabb956a6097a5eaa082a4c2d96a', 1],
['0xa6fbe8f447fe74d39c2d904d521a2819c4ba7c33', 1],
['0x235987b53ed16a5f331c3648f78cbc148a877d27', 1],
['0xc1a701020d6bc503e4b0f995ec4a18a7adee9fa4', 1],
['0x443c019236b28f9a94a8a79784a2d2cf0202bb8f', 1],
['0x1ae79078e50f2ef2c33e47c616007d561a11c42e', 1],
['0x56f3e748acf7f2c219d7b8f65be8d5c233fc114a', 1],
['0x47c82cd97b0b2c883e6c5cc27fbd5263a58ce476', 1],
['0xe2f6aebd4dff1c6593fb0a645d5a6b3ba8111a38', 1],
['0x004d415be7d9ef539e16f4a9d2e5d29c06789ece', 1],
['0x1a0e11ba1e2b85dca648fae5c0a4f8c36cbc0937', 1],
['0xc0fcfd732d6ed4ad1afb182a080f31e74fc0f28d', 1],
['0x93a24d1be1a5f90502e50d04bf4c15c7b3081bef', 1],
['0x93fbdcf0bf499a89f7e2c0f5c7cb934b37c5b679', 1],
['0xbfe9db4695fcf40703638ab3a6aa31364af1fad4', 1],
['0x0b42689410ba244ab61a8f90a9bc28bad7fe8e94', 1],
['0x02608d35121db289427f6fd4fa53e93b5cae0bdf', 1],
['0x8a6ab47b1b794275c9e4d931e1f096de117d775c', 1],
['0x8c01bc945b4c2e659afd5070243a2052da0b5479', 1],
['0x39c4274ced5681802b2ad9fc83ec6b9d53f8a637', 1],
['0xdc7bda7aac7cc9731ec5d6c2a9cf2a768e062b35', 1],
['0xbf78c93cfde5500d1cf6bd1e0eabc2fcdb2770b3', 1],
['0x251612075db39256e11f2ce8fd5e91837ec41cd3', 1],
['0xf09f478c31c247602c019c5c1b700e766ec5fe10', 1],
['0x17356d295134db7e708d84954d6dfbb93b5a2ccd', 1],
['0x6b9cee98a4ca6cff357f576fb2a6cb2b5e43c39f', 1],
['0xad615f88d4483b80dd415a0cf533c027d6ecde01', 1],
['0x73a9f4b6472ea17179da6bb8ffe10854f2e5b53c', 1],
['0x5b6a1ba8bb103e34956fe3197c182200c75ee0d4', 1],
['0x8cac1694208f461a192f95c7fed8de18aa74c542', 1],
['0x329357cd919097a55edaa79b6092317d2d5218c1', 1],
['0xdf5e92e18c282b61b509fb3223bac6c4d0c8dee6', 1],
['0x83c3b1a0e7c9d3164e2bd37dd4c646a2ba81bcfd', 1],
['0xc5d1163209346c9a538566f706c6bc8ad68c2fdc', 1],
['0x8c656aabd8829f681f5bca37313f69a85d283433', 1],
['0xc1490ace8c1805f98b309971dad72503167a6fa9', 1],
['0x81134166c117ae6c8366c36be9e886b0f7147fae', 1],
['0xaa950d1cadd39935ecf1a11eb9f44955f21d3c90', 1],
['0xfb05ee9adc1a66b95003e963a3ae9ff44d4e4cb6', 0]
]


export const leaders2 = [
['0x3d7280047ff3c3937414f29debc7ae203240c22d', 1449],
['0x8c695d728b426e7a16052e32e8ca72777ed51fbf', 1388],
['0x38444084f5df238787f9094a61c5988442c09077', 1387],
['0xc43e0f7439e691a6010fb295ec268e3077f60ec8', 1374],
['0xf0ec9ffecd63fc4fbf764c71daa13e319649a5bc', 1374],
['0x0454ba258a8f3325766ed33c0aa7d75c5f57480d', 1374],
['0x41ee7c363c03e6c4691b0dec51be752608f711be', 1374],
['0x22ac19d26e74e3f0311968ed6db8531111e9f08a', 1374],
['0xb69d4bb72c67b218bf1ee3de9f2cd60e223bbaa9', 1374],
['0x30f2d21100a0e69421d8e4777c2abafea8aa88b1', 1373],
['0x166a3f817c8351951f1377d82d9166b5f4605058', 1373],
['0x8ea245e115e950f5416f716e5bf8bac2339de128', 1373],
['0x7a6e25a516803295a02b267afdc9b8f724856bdd', 1371],
['0x34f9cadaa1d9ce3ec7194137cf5d2cb1fe1ea198', 1312],
['0x36fc4872d2789d12b13dafc8fc7344eb801c817c', 1260],
['0x632027d15cd8e6d97991771bf0d6a01b63b16c81', 1249],
['0x65b6ebd54237481957a009092b1ff3dcd47d873d', 1234],
['0x03ec2225e1239f21041bae563d7a4eee74dc71b5', 1214],
['0x39c0282ee43fba5a91e0397e88add395e5e9f3fa', 1186],
['0xd1e76a69637f73f186e2b27ee7abe39c00393113', 1180],
['0xda944123a5f5e970f9d6f9c21c54968c87de6d0b', 1155],
['0xa2f7ee60f19be79f53f8ac28badfe5081642bfee', 1150],
['0x6cb2fc304d504acc815203b3009cbf4dbc21985a', 1149],
['0x6b22e1ac6940d2832607648fff3d7ca8a5224ba6', 1148],
['0xb11495b1656263bf65228b9238663ebc62f843dc', 1118],
['0x2bb49f11131f5537f46cb356a1bf93a8169a2720', 1079],
['0xeab8e50f305c3b97aa5eb818e09a59124c357b91', 1077],
['0x5bbce406d80d2a50bbf169708666407eec686159', 978],
['0xe8d00e3bc224d9f55c70325634f37a161e45eeda', 978],
['0xe7f969671f7dd4f37fb2b0548041e2fd3569d228', 974],
['0x19d269c688d34f3769fed1e2d1841420c67f96a4', 931],
['0x8774a4e5f0f753a19dea902326c58c56dc6e33e1', 920],
['0x4d4a6aff095f40070a072fc877d9293d1341e628', 910],
['0xe58ba8773b490236855efb8ff0e8979691409743', 905],
['0xf1db24850684eb675f30013d82d5c0ed030b5634', 902],
['0x917f62a8703b5c834f45c42280c292b21222100f', 895],
['0xabbf75a59ac8838fa46bd5260501b68ab28b95f6', 863],
['0x6ddd6d3408c2ddb8064c034350ba3dc9e658bdbc', 836],
['0xe0caa84c7ec5e90872f6ddab8fc3df4595f02f56', 834],
['0xb64c2e41ad313d25ce643a58b876fbe87427f96a', 829],
['0xcef00595a2377e2239524106e6117c8599ac6455', 824],
['0x0db0960e1e358875c5a39a2422425a8513dd77ae', 818],
['0xe5845761e7773976055f2559ca54be41f09d9e88', 803],
['0x7f5cfaa45774928e28c3792e9f710d85b51b0aca', 801],
['0xe9e35f95472c122fc0dbe351c0f7fbbc0ea65686', 798],
['0x1063d7f8225f69698637f7fefc3a339a1eb21cf0', 787],
['0x3da2b5a4838ea10b9870a65a1571da989a519079', 773],
['0x7d338502490c840f1a0c4300ace2e69880228bcf', 757],
['0x902116316d1bfc0c7f4a6a412578770eb215efd0', 751],
['0x3f5c7570dca29f498df81b36accb0b301aa78a54', 749],
['0x329357cd919097a55edaa79b6092317d2d5218c1', 744],
['0x386dd672ef74673c477848c7994c186edc9d3fff', 739],
['0x2d19624dd8bc9bdb4ae1460cf0f9d6d3a2b04199', 735],
['0x11da8f19361fc815074f1f86f4a9216984070b99', 730],
['0xb7a2707329df1e9a89718b56c8d39502edcf222d', 694],
['0xae9c29d8e6471c128545ca46904f7c41e0fbfe65', 690],
['0x216c75302c8f840f16c392c799a248dbe6078701', 689],
['0xb1607c451cfede2cdad8f408e8a77e76cb907219', 689],
['0xa3d157b3fa2c392ce6c340e65ffe48670bc676ea', 682],
['0x7b03d246ddaa1c3945a3d7a1cb6fd86c881be8e6', 677],
['0x37e24d02d1d47462a49f002bac9d60076ea78c20', 677],
['0x826bfc974f01ebce2d03ed207864c5aab0096c0c', 676],
['0xfbfb31c1d4283d29cca1ab9ba25fb0a27f2eaa74', 672],
['0xe7891ff5f0e6e39fbf49b523e2ca7bd22e7782b7', 668],
['0x3369a22b2a1fe3811024df880f17cee9beb1fe6c', 660],
['0x5ebf21454f82298ccf92eb6e2d3ffaa383a72176', 653],
['0x3165355176d654f38abf9e77015000c91fc0f170', 653],
['0x2461eafb9c4d9942c989e41e5036a8808f86eabb', 653],
['0x338438882e53a54d8b4af5b278e58d42d9683eea', 622],
['0xafafcb552bfd919d5a6bfdb8af0c7a72e36dfdee', 588],
['0x8037ccebebb5af26459d6ef3aa974e2d65fb7c05', 533],
['0xb38d67283989c35317c64cfafa901a36d722a271', 531],
['0xea38c3f8a58d05f890848efcb4a22678c78e00ad', 527],
['0x8b6b7cd9cf40d1561532b7bc9643d12139a45f8d', 525],
['0xf923560ef6d74d310534fb45ae2226a8ea325b03', 501],
['0x73b1b3410ac9c28216a0012aedc6926436518f50', 492],
['0xaccf339e9985ee2984aef6ba0b4605bea3d3fd88', 491],
['0x3c04175d395bb8247ba573469984f9bc94d3c115', 487],
['0x42a1ef5ffdaf134eb958814e443db9c244375c8f', 485],
['0xe1337d40a2fdf07f75fbee336204b89f5b31e525', 457],
['0xd4b2905ee116d13664840f67c9374b768d1297ed', 454],
['0x9f1031df92c7bd2a082d16a47a020f637bc4969b', 454],
['0xe27eb33d63ec9b6073fb5e31e10b5be3439d96ed', 452],
['0x3f9825d92a98b14127fc8dd1513fe2c8751901a2', 437],
['0xda6a10b3bfd88c8658c6edb94ca1fd6dea62889c', 420],
['0x754aeb6c334960a415be6825d4868ec860360655', 414],
['0xfe4995a7d93bb16d4aec5b2226ad1e39b0a66ed1', 414],
['0x60b4776bb6ae0430abd7785c5470dcf197d5282e', 413],
['0x777707aba08b324c753cb547a308ec39fd69aa9f', 409],
['0x4ba582b83200d0eb61ec502b6cfa5d48477a72a1', 398],
['0x43e3d95491ddecf81e5f27d30e100a58a8abd761', 397],
['0xbafbd9637af2b66e23dcbda351f4977d6288cbf7', 393],
['0x411258961fb281192da51cccb65732f967d3a2e5', 379],
['0x37d6258662ef824a4eacd5712546a875fb6f7f51', 377],
['0xb31f7728aec8edb9dc68f3a84947684fec33a4fc', 373],
['0x5d02c857e98465f5b3a957b1f43569c4dae58ca0', 363],
['0x6d1e0084a6910a8803ab7c22483a1a2db3f1001a', 361],
['0xcdc7b771a0ef67519cfeba630451bfe1736ef344', 354],
['0xdf9e2288b48176b1f4b12548815decc09e9f2f79', 351],
['0x7ad6f107e816dac44cf7a823f0b7b292a56a1723', 350],
['0x188c66961ef9ba9289dfb53baf6f281c90b0bf7e', 349],
['0xb35b15694f5a9966db6c028636d4420c3113b398', 333],
['0x4f1b197f1068983d6a63ecb47b7ea6eae744c788', 327],
['0x98bd996e969ab447d85414a8bec45e3e85fb0776', 322],
['0x5e92f2482778bb2faa122f3de6137790469d78ff', 320],
['0x69e23912728d62bcd2640d96fbdf06767eb2d67e', 315],
['0x73531ff0baf770eafdc25003fad6e33f7db682eb', 310],
['0x656a41eebec46a6f3709783c8c93c2e522d2afeb', 303],
['0x87d9fdf0ef434c581cd4a410df6fd736349faa4b', 287],
['0x630204233b046f477a4b0faec1d14e9f637e3773', 276],
['0xb4bd807c9cdde19ae1498c7b7006713268e25997', 268],
['0x316602445edb542798a4ebd470f3f57fb8641e77', 256],
['0x199745e7b4efead0b2f027e3c3c88b1c77b3b780', 241],
['0xcb0ff126ed01183c1cc45ddc3798e5f923cf3abe', 232],
['0xe716bc88a611a481750663d7e4fcfe60c2f6fe6f', 232],
['0xe03a07aa1010549d74adf04a94b04d74e5a48aa0', 232],
['0xed8e924735f590572361b52657abd9a3260f35a0', 229],
['0x1563c4751ad2be48fd17464b73585b6ba8b6a5f0', 221],
['0x22e0175c9ddc50e0e66753a0537f4029cfcbb1e7', 218],
['0x492dcea5f6a71e74375b91ae474521a353d8348a', 218],
['0x5c803ee6f40dfded2923277a8053a28eee43bd82', 216],
['0xeb6eb2b7d5bfcd2550b2200dbd2857379e5cd00d', 212],
['0xbccc3487497d3224c71eac036f5f458842c96c92', 206],
['0x82c854504f266dad4a7ea9e448ca7b1572aebf1c', 206],
['0x97e24810ae6914d29d89e79ce3e663d83f20d0bb', 199],
['0xeda5942831bd8b391c52fd7896a123e9d2add51a', 197],
['0x5d0232e0e4ce0de74266313a2b7b01dd5a7c920d', 195],
['0xc96a2dc16d2231fa0c8b572f2bf34d9cbfeb8ca6', 191],
['0x302d7125e4974ea52f85938cf2bf62844cbef510', 188],
['0xb8d86d6db117e21c27636034d3dd8859018daf9c', 181],
['0xaee8212c786c724d5682735d906a7b1e459fef3f', 178],
['0x907f11655ae7a436923b7949341c65a8213ab250', 169],
['0xb77f2aed45c27e8186837f6311a067c4979cc3c3', 166],
['0xb40488bbde7c183c8ef9d6ba4a8682662d1d0b0d', 161],
['0xf947c3c9ada5ca0995d56802bc8a21c5e8e523dd', 160],
['0xa380dace2095adc258d2be066e2a60a9dbacf7ad', 158],
['0x234356a188694abff3a23261fe66231391ce1d44', 155],
['0xcaf58bbbadc001c5696e0da0313a47cf6b946d6f', 154],
['0x218aebe8440674a0d6e4a9ee18154a2da645b163', 152],
['0x128fe2989e1827d16bd9ccfdfd107f937f0095a8', 152],
['0xb0ba26dedc9c1ddae319de606c3b1279e26be57e', 148],
['0x823b6b8da270906f0a231223e46edb5bdea3ff13', 147],
['0x9e138c3c1249f1627168d02359a4ba82e5f2ebd4', 147],
['0x01a28d73010194bc8e503733928829312e73ab87', 147],
['0x649ca3075667e4ddcbfa268f7505ba615f3a925b', 145],
['0x27d83f1308665e2be54faebc11a53457f85fa016', 142],
['0x7d828b25640079d2461fde495f4b129c86abce12', 142],
['0x72f4e8b893527e3884bb4ac5a28d5fc65172ec4a', 142],
['0x0282e055d3b2f7c0ad656952ac1bb989fb6d0086', 138],
['0x1e6cb6a6d61c35183f0e1ac8bfea847a3752b3e1', 136],
['0x24786c256a187cd90d869574ab43df903145d3d1', 134],
['0xb1d009a27f194ad430430469c27aadfea7a0bd6b', 134],
['0xbefd65b66b7c314747b3146c2e0998f4b151ae7f', 133],
['0x1632450f45ab11f38b1dd580371be7ac6db452cb', 130],
['0x9d819695056bb1a372f9e715af5ec4c79595b67c', 128],
['0xeaf9a74ba2928a903366bd42339f1bbf1cbdaa59', 126],
['0xd71d837b8ce264e9a24acf9cdaeed32628acfcc0', 122],
['0x189589abc6794f1c9b385099849c49598e987a68', 121],
['0x8de3c3891268502f77db7e876d727257dec0f852', 118],
['0x583ca46d558bb5011171eb71c6a63eafaa266e8b', 111],
['0x1ccb144b700ec726d37db38c617e154de6d9c0d0', 110],
['0x77c681753979400dc7310b770e88d9c823d1d808', 103],
['0xcad0a207c41399d0c8d4d57101985f47fa9e5903', 102],
['0x883ce32e186c69559e94c8ba276bfc4322fc194a', 101],
['0x579c0c05b15e9268e33f00a49aec8b7cdb8c4f27', 100],
['0x38dc04ec68ab54092d2a5ba01fcdd288f8a83107', 92],
['0x61125f52cee83ed5d7a6cd14598d34974b11865e', 88],
['0x2cd170d34740d2356c464f6bffec1d727a6c96e5', 83],
['0xb2085ae494577852a35bd836459da149780130fe', 83],
['0xc7450a7c19c366c283d21ba362b3eb7ccb8cb07e', 83],
['0x5b3067c5e26fec823d6fbf8f315e43632658d2f6', 83],
['0xe1f565b74de13bf83ba6b79a6b492b89ce9fea91', 82],
['0x8ea64ce37b7b43974905df5afe6fcfeff424c0a9', 80],
['0x01223843daba104d5cfc48006a8f22e777148971', 78],
['0x2bc79880f05ba1460ef2cc6b04b4ddf11bf43a94', 78],
['0x2ca43ede57dc4bc707b4ac9ca9c77798cfc6bd9e', 76],
['0xffe3385962b6bf54860f06dd35d5db3504bd1286', 66],
['0x5d0b9beb7a0853ca712985c26939d023fa7065aa', 65],
['0x9d2699358b4111eb4f8a2901d2f68c3c0cb2aeae', 64],
['0xf0b9aa2a5b8e6ce7b18b3c832cec1d742848f115', 63],
['0x499654b8d5ba3d318fc80ad478d28ca3530e4c65', 56],
['0xe14f785b0f71900b1a02f9c26be44a0e21990afa', 54],
['0xde8476883a4b9acefcf736a8f97bce1f1fb54b37', 53],
['0x44e434b0eb83534b697f9c77ef11fb981b637def', 50],
['0x19246d4cb92671d0f2166d00c9de687ead3206f8', 50],
['0x452b82a918e0456880a4d3f2da1242f7248aa48b', 48],
['0x68aedee7dc9da33a1e7d32a6637361e409c40519', 44],
['0x3644dbaf8dcf85037e2c9bdf32ffd5bc4592bb6d', 40],
['0xbfe709589e8fde046fc6d60edbd2bce1299e76a9', 39],
['0xd487d777e8e94391efefb37abc15505cee46e147', 39],
['0x6c28570747e25f2935902cdcce9f22895764cdc2', 38],
['0x4533e03d983fae04741131c5f7cb35f1b32a1acd', 38],
['0xf5fcaae203bd5dd81ef969c3fecc872f38aeccab', 38],
['0xe9e71aa6c8639403e39755f6b0a3805d9cb8d057', 35],
['0x242d96508bf41e152739280a822d707d99c9b876', 34],
['0x9aab7069ac7c9447cbca511f448b36c04be5476e', 33],
['0xdc556cb123db4172fdb0dc8c95bc0a7132b9487d', 33],
['0xfee03b642100b9d5b1beb5a9f5c1db190d6837aa', 33],
['0xe19763baa197e17a5663f8941177bfbbd31a7ab0', 32],
['0xa89f7a583f477212f99d34ca1d379c934831a210', 32],
['0x6c3ad0aec8e8b9aa3a58c839e0f5f0ace1fff981', 32],
['0x722d97398ed670be033e3a435d590e82ba50a72c', 32],
['0x7ad92e2b66c772ca9c56d4b59660ed537b28ab90', 32],
['0x11584d6aaebfdbf48cd5a11599bf40b5bc386837', 31],
['0xe06d67e2cd5c51cbe0ec603a1e314039875e0ab2', 30],
['0xa9b815846d364cdf54e5cead6b6e199d77aeef13', 30],
['0x64acef3297972c9bfed88af18926ffb639ce0ab3', 30],
['0x1363150a96ce368838bff7f7a4b399811ab1a7a3', 28],
['0x86575e8371bb8270173670d0e045e64f073936d8', 28],
['0x1016112b289bcd8fd00d11391e797fddb379ce2f', 28],
['0xc0a1162c3ff721daa7e0141eb639cfb5765ea589', 27],
['0x9fd634393707ad07739d63c81011ba067681a19a', 27],
['0xf73bd5710d3e3d4e8db7ec6058f9fb77ff8414e9', 26],
['0x09d6679f6913b32ccf0cd3803e688a3a496452d7', 26],
['0x0f4cbe532e34e4dfcb648adf145010b38ed5e8e8', 24],
['0x30e12c32dd4ac3ac28122990fc43e36e74f77515', 24],
['0xc29dac18bf481c1615caebea293b84c15b383828', 24],
['0xaf7706e18abd8af56b1b9fd4d02af130e0d36d53', 22],
['0x73d1e13dd076e1c3292ab503ffbf56f3c72bf846', 21],
['0x08e0ab9353d1d19813719cd68c3454cdc66898dd', 21],
['0x51a1476c2c4bc15b72a705b734a2ac0a9e99e71a', 20],
['0x9ab6f1202e39d65b8b4192445a714ee39ae203b1', 19],
['0x9015cfe99fee5a2f5a01c2c6b89393bb166d6dbb', 19],
['0x287074d5780dcb5fdb084bf99676079f308a5f3b', 18],
['0x888d08a60678321a41e54c20fc0e9d5acdeeeeee', 17],
['0xfe7c2b6ce4b61ac06c83637154e4ea05f665b5fb', 17],
['0x9718bff14b645c4e02adb9e7b64fac03b2867c71', 17],
['0x043cf0414ad2991e910e464e4f3e80f14d7cf0b9', 17],
['0xb946795a5cebb3f252f7ae7d38ff83b9ad3031d0', 17],
['0x0d570e65873f012f0437864abb4ea9e3ddc6d87b', 16],
['0xc9eebecb1d0aff4fb2b9978516e075a33639892c', 16],
['0xb0fabe3bcac50f065dbf68c0b271118ddc005402', 16],
['0x969d6e2c983dd43aebfc7d5b07ce58cce65f9cb4', 16],
['0xa91792b5f297148f89baf4fed67f647122ea833f', 16],
['0xe8fecebac598ada02f93ccd8a25cff79835efe43', 15],
['0x19739686960105e8f2f34f7d6537da651ad19157', 15],
['0xa48267bd12592ae4a3a5c4f8b0fc273e58531e2b', 15],
['0x9a2a659980a8fd84790b456696000c8eba9bc578', 14],
['0x39129dcdc2f836653b6391edd991be4f4b675c8d', 14],
['0x03f1a715650814e31eeea113b3145981071dbfbc', 12],
['0x752d5a59d9cd3ed8af87e0c8939d5d19db168331', 12],
['0xb304102b01d197804580f2d5a497d6ee7a32523d', 11],
['0x540f3bf895ff2d10db9d9fdf5cd39c8313fd8d6c', 11],
['0xb2a03b41c7e06512fbb852443a143c664bb339e7', 9],
['0xd88cff1d9f7e0e511ca50f6f169c03354b384135', 8],
['0x4976d2d3122c5d9392237efc1c1010bb2efddb81', 8],
['0xb86b5568853c5963dd9b9836f5ec94a15966bbc9', 8],
['0xa16dd5dc89d9e36524e3b75de78515ed7ca4f1fd', 8],
['0x9293548e4b270450ce46a3168c9e5985d7b806d2', 8],
['0x657c79bec8dcd761cd5aa8c0419ea59e1515ec1b', 8],
['0x438f57868f7499054f392a8676ceb8dbeed6d433', 8],
['0xeb46009ce44f0a423658462df8af6cee629b190a', 6],
['0x00e81d0d81012e24a8c39aea69a9816c85409201', 6],
['0xf82fe7a94704598559828bfaa76393d47a81bf73', 6],
['0x6f07614ead08d1374c4d2dc794a77edb4c252b88', 6],
['0xd9010fb0b7df8bd85b7b614c01df9a65e032f60d', 5],
['0x7a25e9bc4774d94dd310185700c429c42d25a069', 5],
['0x63008d38350cf08f75a90cd0d7c076f452be2243', 5],
['0xb1fc41cbad16cafdfc2ed196c7fe515dfb6a1577', 4],
['0xa6b6d854e4e5f2b36e51d1dff81cad56e5f286c1', 4],
['0x97db0e57b1c315a08cc889ed405adb100d7f137d', 4],
['0xa21e8b6757893577c27662ae5afe32e73c9dc4dd', 4],
['0x51616b471089cdc15b51f5b2c592e4cce98297f9', 4],
['0x1385a6aad6e6f7a396f7041b60807ce11306b4d1', 4],
['0x98d5ba40a5407c73b63842a027b4c17e6c7553cd', 4],
['0x2684d73ca86638f656eb6f98f725fe317076d99c', 4],
['0xbb12c5453375332107b24914d169b6ac99bdea8b', 4],
['0xfc8084cf7e0f916f114f9bdd8a86ba2427efe976', 4],
['0x22e916361cf092c02a12ffc57a55447ee1a6da3f', 3],
['0x6b9cee98a4ca6cff357f576fb2a6cb2b5e43c39f', 3],
['0x75405db3efddc536bdaff015782b81eedf3e900a', 3],
['0x729f6d2383f5178ae1a76b45b8b69c7983b53aa0', 3],
['0xd5cc9763394741845a4848cb897cb684686d0000', 3],
['0x4ec616f2a7a55d93941330709b32e959bdaf9ebf', 3],
['0xf2e4a05cbae83fb3173becee7a31686e8a6ae3ce', 3],
['0xcd0f8ad65a92428b9ecebda3141833e79ff0f6d9', 3],
['0xd8cf3e31820ceec940c69f462fc047d306bcb984', 3],
['0x63e6e54e39373d74260c48af537fa4a9a4c95506', 3],
['0xdf5e92e18c282b61b509fb3223bac6c4d0c8dee6', 2],
['0x17356d295134db7e708d84954d6dfbb93b5a2ccd', 2],
['0x8c656aabd8829f681f5bca37313f69a85d283433', 2],
['0xa6e950aa70ebaaf99686a5d95afe8aca8b5e353b', 2],
['0x5ebe38048d34a5a82cf45e2e030d436275656577', 2],
['0x9c0c06c6213498db58550c05c36879c620b3d26c', 2],
['0x190df206d103b3edde9db6be2bd3ea54752d97dc', 2],
['0x857d5884fc42cea646bd62cc84f806aeb9a2ae6f', 2],
['0x01f109ac6e947715b3c3c506ee60d324d45edcd3', 2],
['0xaa950d1cadd39935ecf1a11eb9f44955f21d3c90', 2],
['0xa1c234ed82d0dd0ab5bc2cd0d231fe65cd3b579d', 2],
['0x548d3b9d71c319a5e7b46fd5671e54da01c0982c', 2],
['0x39c4274ced5681802b2ad9fc83ec6b9d53f8a637', 2],
['0x5f57ec03370cd600294b77025020c464daf31640', 2],
['0xa85d48fb167743e1518ac8c6045678e1dcffe623', 2],
['0xb2ae7773e14d857d1202cfc2a6a5a2a3de1525f5', 2],
['0xd57497aed2324517f801b5cf8269edf996907a82', 2],
['0x96126f8dc9c228b3579c4c2d3f2f7262066e1168', 2],
['0x8500faf6985253409efaf6fcc02aa4bb84c949db', 2],
['0x8288090f6016bd90dc234fc619baeaa6ba031ba6', 2],
['0xb1ed930c6cfbab7d125251925d3aa19688db890a', 2],
['0xefd094b4374a5c94dbf34f76a20fa7503a144fbf', 2],
['0xcef1d967d02ebbd6c4d34ab2136847ee25ca7df6', 2],
['0x4d9bf58c49365846f0fce115e0069a65a3c35ec9', 1],
['0xabfdf09d6d853330a4e86a2499c6cd34ff616d36', 1],
['0xdb63db0d4320bf2edacba6f9c56eb5bba73d5a8f', 1],
['0x6c0d470d97ef1f230eef10a5c848afcc8261ed67', 1],
['0xbe72d4a70c047adc435be93b7e8ccde6fe431f58', 1],
['0xc78e8ea590c6c75c346fe8c7b1ef302cffb9af0a', 1],
['0xb2c1119c4ae30ce46af14b67131e2277aab89d88', 1],
['0xa6861734e12e45e3b3a1dfc3d06d1bc5d3c34589', 1],
['0x62c6e060ea69b7c6d145b73bc834ede9a1b7eed8', 1],
['0x2800d8f97d54b283f782db3b005ad8333c166b39', 1],
['0x61560578483faaffa3c8db1b0f4ad675ed1068e1', 1],
['0xc9673d68c30d0beb6d11a8112cdf00bc6eccb98f', 1],
['0xdbab0b75921e3008fd0bb621a8248d969d2d2f0d', 1],
['0x895561a75dcefcac3a35488bbf7b2bbca950e5a6', 1],
['0xb1f87f5fb92f4005be79945e33bd2d5faa2c01fc', 1],
['0xfcd3a9d877face26343a34eb6f402f747f8987ec', 1],
['0x4ebd6287f4a697a3211d07a83b5248e6d3015b26', 1],
['0x8c2205e0fe3725666646d8b2b91e8d1bddcc6bf5', 1],
['0x672fd76b1d6c6287c3dbca06506552ab4f113c43', 1],
['0xb11766a8c7329bdcbae6bf833b578559d385d37b', 1],
['0x1e34b42f23871aaf6a8bff113d7241ad6b936ee7', 1],
['0x60c7769a0e6d4807765ca89b28162fc6e3a49c58', 1],
['0xc0ded526a536f24bca0bac704f3a9247188aa506', 1],
['0xd89bcf9a80cf367174a83f33aa894e002cc63278', 1],
['0xa1d76adef8bc9151490c0f66ecb0ffcd800c3e38', 1],
['0x7404aab275b3d2d2404e00e650c25f995fa43876', 1],
['0x0b42689410ba244ab61a8f90a9bc28bad7fe8e94', 1],
['0x50ae129468ce09e27c814070e267307471a654c1', 1],
['0xa345da1baa92b68e5545777e5e2ed7cb6209818c', 1],
['0x00169219376146760298417404949075285cab72', 0],
['0xf4c9bc6fd4199f7fe0f3c0a6443fa2ccf9b4ab66', 0]
]

export const leaders3 = [
['0x34f9cadaa1d9ce3ec7194137cf5d2cb1fe1ea198', 1024],
['0x63008d38350cf08f75a90cd0d7c076f452be2243', 945],
['0xe7f969671f7dd4f37fb2b0548041e2fd3569d228', 868],
['0x42a1ef5ffdaf134eb958814e443db9c244375c8f', 850],
['0xcef00595a2377e2239524106e6117c8599ac6455', 811],
['0x3da2b5a4838ea10b9870a65a1571da989a519079', 801],
['0x6ddd6d3408c2ddb8064c034350ba3dc9e658bdbc', 769],
['0xeab8e50f305c3b97aa5eb818e09a59124c357b91', 756],
['0x4d4a6aff095f40070a072fc877d9293d1341e628', 732],
['0xe0caa84c7ec5e90872f6ddab8fc3df4595f02f56', 720],
['0xea38c3f8a58d05f890848efcb4a22678c78e00ad', 689],
['0xe27eb33d63ec9b6073fb5e31e10b5be3439d96ed', 682],
['0xbafbd9637af2b66e23dcbda351f4977d6288cbf7', 678],
['0x43e3d95491ddecf81e5f27d30e100a58a8abd761', 677],
['0xfe4995a7d93bb16d4aec5b2226ad1e39b0a66ed1', 673],
['0x60b4776bb6ae0430abd7785c5470dcf197d5282e', 667],
['0x777707aba08b324c753cb547a308ec39fd69aa9f', 659],
['0x902116316d1bfc0c7f4a6a412578770eb215efd0', 644],
['0x6b22e1ac6940d2832607648fff3d7ca8a5224ba6', 643],
['0x0c772254fd559a54a8cf879050c270f2b80fd2be', 637],
['0x754aeb6c334960a415be6825d4868ec860360655', 631],
['0x4ba582b83200d0eb61ec502b6cfa5d48477a72a1', 626],
['0x632027d15cd8e6d97991771bf0d6a01b63b16c81', 623],
['0x39c0282ee43fba5a91e0397e88add395e5e9f3fa', 620],
['0x2461eafb9c4d9942c989e41e5036a8808f86eabb', 595],
['0xde93e8f6e290bbe8817db8d73d70bbda9a8c677c', 568],
['0x0db0960e1e358875c5a39a2422425a8513dd77ae', 545],
['0x11da8f19361fc815074f1f86f4a9216984070b99', 503],
['0x8774a4e5f0f753a19dea902326c58c56dc6e33e1', 479],
['0xafafcb552bfd919d5a6bfdb8af0c7a72e36dfdee', 460],
['0xf923560ef6d74d310534fb45ae2226a8ea325b03', 459],
['0xb38d67283989c35317c64cfafa901a36d722a271', 445],
['0x3c04175d395bb8247ba573469984f9bc94d3c115', 429],
['0xd1e76a69637f73f186e2b27ee7abe39c00393113', 422],
['0x44e434b0eb83534b697f9c77ef11fb981b637def', 406],
['0xabbf75a59ac8838fa46bd5260501b68ab28b95f6', 404],
['0x3f9825d92a98b14127fc8dd1513fe2c8751901a2', 389],
['0x2bb49f11131f5537f46cb356a1bf93a8169a2720', 386],
['0x70b0046c1fd19439d5acd17a86b2f0d24dc99227', 376],
['0xaccf339e9985ee2984aef6ba0b4605bea3d3fd88', 355],
['0x1063d7f8225f69698637f7fefc3a339a1eb21cf0', 351],
['0x8037ccebebb5af26459d6ef3aa974e2d65fb7c05', 339],
['0x302d7125e4974ea52f85938cf2bf62844cbef510', 322],
['0xbccc3487497d3224c71eac036f5f458842c96c92', 315],
['0x82c854504f266dad4a7ea9e448ca7b1572aebf1c', 315],
['0x9d819695056bb1a372f9e715af5ec4c79595b67c', 304],
['0x9f1031df92c7bd2a082d16a47a020f637bc4969b', 301],
['0xe1337d40a2fdf07f75fbee336204b89f5b31e525', 288],
['0xb77f2aed45c27e8186837f6311a067c4979cc3c3', 277],
['0x27d83f1308665e2be54faebc11a53457f85fa016', 257],
['0x69e23912728d62bcd2640d96fbdf06767eb2d67e', 240],
['0x98bd996e969ab447d85414a8bec45e3e85fb0776', 221],
['0x657c79bec8dcd761cd5aa8c0419ea59e1515ec1b', 215],
['0x411258961fb281192da51cccb65732f967d3a2e5', 204],
['0x5d02c857e98465f5b3a957b1f43569c4dae58ca0', 199],
['0xb35b15694f5a9966db6c028636d4420c3113b398', 198],
['0xb69d4bb72c67b218bf1ee3de9f2cd60e223bbaa9', 198],
['0xb8d86d6db117e21c27636034d3dd8859018daf9c', 190],
['0x01a28d73010194bc8e503733928829312e73ab87', 182],
['0x72f4e8b893527e3884bb4ac5a28d5fc65172ec4a', 181],
['0xb0ba26dedc9c1ddae319de606c3b1279e26be57e', 167],
['0x6cb2fc304d504acc815203b3009cbf4dbc21985a', 157],
['0xa2f7ee60f19be79f53f8ac28badfe5081642bfee', 156],
['0x917f62a8703b5c834f45c42280c292b21222100f', 156],
['0xb11495b1656263bf65228b9238663ebc62f843dc', 155],
['0x87d9fdf0ef434c581cd4a410df6fd736349faa4b', 155],
['0x88677d4919f5482fa73c1da002429d8f44a98dd2', 154],
['0xc4799c2421baab898625f859330801986d6c5d5f', 154],
['0x1d0a1909ccb1dbfd8d92f2b4ba7f8ad38ac9bcd9', 153],
['0x6347965ba46964cdcd48c80c436fca7f5e7d35f8', 152],
['0xf9c9afccfa1701501edd80a84ae07ea8d156411b', 148],
['0xe06d67e2cd5c51cbe0ec603a1e314039875e0ab2', 145],
['0xf947c3c9ada5ca0995d56802bc8a21c5e8e523dd', 143],
['0x579c0c05b15e9268e33f00a49aec8b7cdb8c4f27', 131],
['0xd487d777e8e94391efefb37abc15505cee46e147', 123],
['0x656a41eebec46a6f3709783c8c93c2e522d2afeb', 118],
['0x630204233b046f477a4b0faec1d14e9f637e3773', 117],
['0xd4b2905ee116d13664840f67c9374b768d1297ed', 116],
['0xda6a10b3bfd88c8658c6edb94ca1fd6dea62889c', 109],
['0x883ce32e186c69559e94c8ba276bfc4322fc194a', 107],
['0x2cd170d34740d2356c464f6bffec1d727a6c96e5', 96],
['0x19739686960105e8f2f34f7d6537da651ad19157', 94],
['0x4662b891269e2196e67cca73e4b7812dd91c7ae3', 83],
['0xb304102b01d197804580f2d5a497d6ee7a32523d', 81],
['0x97e24810ae6914d29d89e79ce3e663d83f20d0bb', 81],
['0xeda5942831bd8b391c52fd7896a123e9d2add51a', 81],
['0x1ccb144b700ec726d37db38c617e154de6d9c0d0', 78],
['0xbefd65b66b7c314747b3146c2e0998f4b151ae7f', 74],
['0x189589abc6794f1c9b385099849c49598e987a68', 72],
['0x38dc04ec68ab54092d2a5ba01fcdd288f8a83107', 69],
['0x0bc93dcce6397568e291d5a2bc4751f507a541c8', 68],
['0x316602445edb542798a4ebd470f3f57fb8641e77', 67],
['0x9718bff14b645c4e02adb9e7b64fac03b2867c71', 62],
['0xaee8212c786c724d5682735d906a7b1e459fef3f', 61],
['0xeb46009ce44f0a423658462df8af6cee629b190a', 61],
['0x499654b8d5ba3d318fc80ad478d28ca3530e4c65', 60],
['0x01223843daba104d5cfc48006a8f22e777148971', 60],
['0xb2085ae494577852a35bd836459da149780130fe', 50],
['0x1e6cb6a6d61c35183f0e1ac8bfea847a3752b3e1', 49],
['0x1563c4751ad2be48fd17464b73585b6ba8b6a5f0', 49],
['0x19d269c688d34f3769fed1e2d1841420c67f96a4', 48],
['0xa91792b5f297148f89baf4fed67f647122ea833f', 46],
['0x68aedee7dc9da33a1e7d32a6637361e409c40519', 45],
['0xffe3385962b6bf54860f06dd35d5db3504bd1286', 43],
['0x3f2e7c43c44018ea1c148eda541ccdfd923ee18a', 43],
['0xcb0ff126ed01183c1cc45ddc3798e5f923cf3abe', 43],
['0x61125f52cee83ed5d7a6cd14598d34974b11865e', 40],
['0xaa950d1cadd39935ecf1a11eb9f44955f21d3c90', 39],
['0xc1490ace8c1805f98b309971dad72503167a6fa9', 38],
['0xb4bd807c9cdde19ae1498c7b7006713268e25997', 33],
['0x199745e7b4efead0b2f027e3c3c88b1c77b3b780', 31],
['0x5c803ee6f40dfded2923277a8053a28eee43bd82', 30],
['0xeb6eb2b7d5bfcd2550b2200dbd2857379e5cd00d', 29],
['0x5d0232e0e4ce0de74266313a2b7b01dd5a7c920d', 29],
['0x22e0175c9ddc50e0e66753a0537f4029cfcbb1e7', 28],
['0xf1db24850684eb675f30013d82d5c0ed030b5634', 26],
['0x5e92f2482778bb2faa122f3de6137790469d78ff', 22],
['0x9c6fb33fdbce49c9f95bc7fb7722dcec9cb5ace1', 22],
['0x7ad6f107e816dac44cf7a823f0b7b292a56a1723', 21],
['0xed8e924735f590572361b52657abd9a3260f35a0', 19],
['0xe5845761e7773976055f2559ca54be41f09d9e88', 19],
['0x4f1b197f1068983d6a63ecb47b7ea6eae744c788', 16],
['0x287074d5780dcb5fdb084bf99676079f308a5f3b', 15],
['0x6c0d470d97ef1f230eef10a5c848afcc8261ed67', 15],
['0xea869669210a69b035b382e0f2a498b87dc6a45c', 15],
['0x19246d4cb92671d0f2166d00c9de687ead3206f8', 13],
['0xd71d837b8ce264e9a24acf9cdaeed32628acfcc0', 13],
['0xde8476883a4b9acefcf736a8f97bce1f1fb54b37', 12],
['0xfe7c2b6ce4b61ac06c83637154e4ea05f665b5fb', 12],
['0x2d19624dd8bc9bdb4ae1460cf0f9d6d3a2b04199', 11],
['0xb1d009a27f194ad430430469c27aadfea7a0bd6b', 11],
['0x823b6b8da270906f0a231223e46edb5bdea3ff13', 11],
['0x4f30c40dd5d28908bca691530d31e48f54fdea94', 10],
['0xda944123a5f5e970f9d6f9c21c54968c87de6d0b', 10],
['0x9e138c3c1249f1627168d02359a4ba82e5f2ebd4', 8],
['0xcad0a207c41399d0c8d4d57101985f47fa9e5903', 8],
['0xe19763baa197e17a5663f8941177bfbbd31a7ab0', 8],
['0x8de3c3891268502f77db7e876d727257dec0f852', 7],
['0x77c681753979400dc7310b770e88d9c823d1d808', 7],
['0x75405db3efddc536bdaff015782b81eedf3e900a', 7],
['0xb40488bbde7c183c8ef9d6ba4a8682662d1d0b0d', 7],
['0x51a1476c2c4bc15b72a705b734a2ac0a9e99e71a', 6],
['0x94578884387f7b385c2184c337249d01f0e81b82', 6],
['0x9aabdbf1ec9c35c157ba456b292ce734c0ad6f19', 6],
['0x73a9f4b6472ea17179da6bb8ffe10854f2e5b53c', 6],
['0xe716bc88a611a481750663d7e4fcfe60c2f6fe6f', 6],
['0xe03a07aa1010549d74adf04a94b04d74e5a48aa0', 6],
['0x0ad3a19a2a9d1b373b72a5740cdea8d544ccfe07', 6],
['0xf89e2e88835481ade9826e032478762130695494', 5],
['0x51616b471089cdc15b51f5b2c592e4cce98297f9', 5],
['0xe9e71aa6c8639403e39755f6b0a3805d9cb8d057', 5],
['0x5b3067c5e26fec823d6fbf8f315e43632658d2f6', 5],
['0xfc8084cf7e0f916f114f9bdd8a86ba2427efe976', 4],
['0xbfe709589e8fde046fc6d60edbd2bce1299e76a9', 4],
['0x08e0ab9353d1d19813719cd68c3454cdc66898dd', 4],
['0xa16dd5dc89d9e36524e3b75de78515ed7ca4f1fd', 4],
['0xbb12c5453375332107b24914d169b6ac99bdea8b', 4],
['0x752d5a59d9cd3ed8af87e0c8939d5d19db168331', 4],
['0x137a48f028be804425428cdd1591675a583235e0', 4],
['0x09d6679f6913b32ccf0cd3803e688a3a496452d7', 4],
['0x265f5a9b3181ef516d755cb890a24a98e7d641ce', 3],
['0xdf9e2288b48176b1f4b12548815decc09e9f2f79', 3],
['0x8c2205e0fe3725666646d8b2b91e8d1bddcc6bf5', 3],
['0xcd0f8ad65a92428b9ecebda3141833e79ff0f6d9', 3],
['0x01f109ac6e947715b3c3c506ee60d324d45edcd3', 3],
['0x55a3aa5a7ecb1c5c738b097e67efe6a0c1be935a', 3],
['0x5ebf21454f82298ccf92eb6e2d3ffaa383a72176', 2],
['0xde6e03c065a5d13a30737fa085bb0041f1614659', 2],
['0xb1fc41cbad16cafdfc2ed196c7fe515dfb6a1577', 2],
['0x97db0e57b1c315a08cc889ed405adb100d7f137d', 2],
['0xa6b6d854e4e5f2b36e51d1dff81cad56e5f286c1', 2],
['0xfcd3a9d877face26343a34eb6f402f747f8987ec', 2],
['0xb495023d8eb9526d8ec346703f2cff12f2a6963d', 2],
['0x3644dbaf8dcf85037e2c9bdf32ffd5bc4592bb6d', 2],
['0x00e81d0d81012e24a8c39aea69a9816c85409201', 2],
['0x919dc858c9f7c8ff5026da39668454f240282d8b', 2],
['0x69a00fafe7e935fde9ecb5c53f23e0e409a33e12', 2],
['0x08a474203d14053eabc30a5bf877bd22a6554f0c', 2],
['0xf5fcaae203bd5dd81ef969c3fecc872f38aeccab', 2],
['0x583ca46d558bb5011171eb71c6a63eafaa266e8b', 2],
['0x6d1e0084a6910a8803ab7c22483a1a2db3f1001a', 2],
['0x0f4cbe532e34e4dfcb648adf145010b38ed5e8e8', 1],
['0x5f57ec03370cd600294b77025020c464daf31640', 1],
['0x2800d8f97d54b283f782db3b005ad8333c166b39', 1],
['0xb2ae7773e14d857d1202cfc2a6a5a2a3de1525f5', 1],
['0x1363150a96ce368838bff7f7a4b399811ab1a7a3', 1],
['0xc96a2dc16d2231fa0c8b572f2bf34d9cbfeb8ca6', 1],
['0xa21e8b6757893577c27662ae5afe32e73c9dc4dd', 1],
['0xf82fe7a94704598559828bfaa76393d47a81bf73', 1],
['0xc43e0f7439e691a6010fb295ec268e3077f60ec8', 1],
['0xc0a1162c3ff721daa7e0141eb639cfb5765ea589', 1],
['0x2ca43ede57dc4bc707b4ac9ca9c77798cfc6bd9e', 1],
['0xc0ded526a536f24bca0bac704f3a9247188aa506', 1],
['0xcdc7b771a0ef67519cfeba630451bfe1736ef344', 1],
['0x11584d6aaebfdbf48cd5a11599bf40b5bc386837', 1]

]

export const leaders4 = [
['0x34f9cadaa1d9ce3ec7194137cf5d2cb1fe1ea198', 1668],
['0x63008d38350cf08f75a90cd0d7c076f452be2243', 1596],
['0xcef00595a2377e2239524106e6117c8599ac6455', 1392],
['0x3da2b5a4838ea10b9870a65a1571da989a519079', 1379],
['0xe7f969671f7dd4f37fb2b0548041e2fd3569d228', 1357],
['0x4d4a6aff095f40070a072fc877d9293d1341e628', 1307],
['0x8c695d728b426e7a16052e32e8ca72777ed51fbf', 1238],
['0x38444084f5df238787f9094a61c5988442c09077', 1237],
['0x39c0282ee43fba5a91e0397e88add395e5e9f3fa', 1225],
['0x60b4776bb6ae0430abd7785c5470dcf197d5282e', 1172],
['0x754aeb6c334960a415be6825d4868ec860360655', 1168],
['0xd1e76a69637f73f186e2b27ee7abe39c00393113', 1167],
['0xe27eb33d63ec9b6073fb5e31e10b5be3439d96ed', 1164],
['0xfe4995a7d93bb16d4aec5b2226ad1e39b0a66ed1', 1138],
['0x43e3d95491ddecf81e5f27d30e100a58a8abd761', 1132],
['0xeab8e50f305c3b97aa5eb818e09a59124c357b91', 1104],
['0x4ba582b83200d0eb61ec502b6cfa5d48477a72a1', 1086],
['0x6b22e1ac6940d2832607648fff3d7ca8a5224ba6', 1064],
['0xbafbd9637af2b66e23dcbda351f4977d6288cbf7', 1064],
['0x599c995d6890f079bf25af0df7413d9504bde646', 1026],
['0x2461eafb9c4d9942c989e41e5036a8808f86eabb', 1024],
['0x777707aba08b324c753cb547a308ec39fd69aa9f', 944],
['0x902116316d1bfc0c7f4a6a412578770eb215efd0', 903],
['0x4516e08a32ac5c82f0eaff5421f57c1bdcbd7ca5', 878],
['0xe0caa84c7ec5e90872f6ddab8fc3df4595f02f56', 848],
['0x338438882e53a54d8b4af5b278e58d42d9683eea', 809],
['0x6ddd6d3408c2ddb8064c034350ba3dc9e658bdbc', 807],
['0x2bb49f11131f5537f46cb356a1bf93a8169a2720', 778],
['0xb77f2aed45c27e8186837f6311a067c4979cc3c3', 756],
['0xb69d4bb72c67b218bf1ee3de9f2cd60e223bbaa9', 750],
['0x5574118e7d744e7a89f4e5c5613ba9934dc16ec5', 661],
['0x0db0960e1e358875c5a39a2422425a8513dd77ae', 652],
['0x3d7280047ff3c3937414f29debc7ae203240c22d', 642],
['0xea38c3f8a58d05f890848efcb4a22678c78e00ad', 606],
['0xafafcb552bfd919d5a6bfdb8af0c7a72e36dfdee', 585],
['0x3c04175d395bb8247ba573469984f9bc94d3c115', 562],
['0x042bd025ffbacbb06222b45aff42e076d0bf14ef', 515],
['0x82c854504f266dad4a7ea9e448ca7b1572aebf1c', 489],
['0xde93e8f6e290bbe8817db8d73d70bbda9a8c677c', 472],
['0x0c772254fd559a54a8cf879050c270f2b80fd2be', 456],
['0x3f9825d92a98b14127fc8dd1513fe2c8751901a2', 447],
['0xf1db24850684eb675f30013d82d5c0ed030b5634', 444],
['0xaccf339e9985ee2984aef6ba0b4605bea3d3fd88', 438],
['0xa2f7ee60f19be79f53f8ac28badfe5081642bfee', 413],
['0xb11495b1656263bf65228b9238663ebc62f843dc', 412],
['0x1d0a1909ccb1dbfd8d92f2b4ba7f8ad38ac9bcd9', 411],
['0x6cb2fc304d504acc815203b3009cbf4dbc21985a', 411],
['0x70b0046c1fd19439d5acd17a86b2f0d24dc99227', 411],
['0x6347965ba46964cdcd48c80c436fca7f5e7d35f8', 407],
['0x917f62a8703b5c834f45c42280c292b21222100f', 403],
['0xf923560ef6d74d310534fb45ae2226a8ea325b03', 381],
['0xda944123a5f5e970f9d6f9c21c54968c87de6d0b', 360],
['0x9f1031df92c7bd2a082d16a47a020f637bc4969b', 356],
['0x656a41eebec46a6f3709783c8c93c2e522d2afeb', 337],
['0xe5845761e7773976055f2559ca54be41f09d9e88', 300],
['0xb304102b01d197804580f2d5a497d6ee7a32523d', 277],
['0x27d83f1308665e2be54faebc11a53457f85fa016', 268],
['0x411258961fb281192da51cccb65732f967d3a2e5', 262],
['0xd487d777e8e94391efefb37abc15505cee46e147', 247],
['0xabbf75a59ac8838fa46bd5260501b68ab28b95f6', 212],
['0xda6a10b3bfd88c8658c6edb94ca1fd6dea62889c', 205],
['0xb4bd807c9cdde19ae1498c7b7006713268e25997', 172],
['0xee13ae5caf40f5757ed890be6330788779984bfa', 165],
['0x2ca43ede57dc4bc707b4ac9ca9c77798cfc6bd9e', 158],
['0xb38d67283989c35317c64cfafa901a36d722a271', 151],
['0xb9ac750bf77f5fa620d40100936811feab90caf6', 134],
['0x883ce32e186c69559e94c8ba276bfc4322fc194a', 130],
['0xcb0ff126ed01183c1cc45ddc3798e5f923cf3abe', 122],
['0x72f4e8b893527e3884bb4ac5a28d5fc65172ec4a', 120],
['0x5d02c857e98465f5b3a957b1f43569c4dae58ca0', 116],
['0x2d19624dd8bc9bdb4ae1460cf0f9d6d3a2b04199', 114],
['0x01223843daba104d5cfc48006a8f22e777148971', 96],
['0x1ccb144b700ec726d37db38c617e154de6d9c0d0', 73],
['0x199745e7b4efead0b2f027e3c3c88b1c77b3b780', 72],
['0x5d0232e0e4ce0de74266313a2b7b01dd5a7c920d', 69],
['0xeb6eb2b7d5bfcd2550b2200dbd2857379e5cd00d', 69],
['0x22e0175c9ddc50e0e66753a0537f4029cfcbb1e7', 68],
['0x5c803ee6f40dfded2923277a8053a28eee43bd82', 68],
['0xbb9261bcca1fa9037e067d48ee55e9cf29435c7a', 63],
['0xc9673d68c30d0beb6d11a8112cdf00bc6eccb98f', 55],
['0xbefd65b66b7c314747b3146c2e0998f4b151ae7f', 51],
['0x1e6cb6a6d61c35183f0e1ac8bfea847a3752b3e1', 49],
['0x7ad6f107e816dac44cf7a823f0b7b292a56a1723', 43],
['0x8037ccebebb5af26459d6ef3aa974e2d65fb7c05', 40],
['0x97e24810ae6914d29d89e79ce3e663d83f20d0bb', 38],
['0xeda5942831bd8b391c52fd7896a123e9d2add51a', 38],
['0x499654b8d5ba3d318fc80ad478d28ca3530e4c65', 37],
['0xf0b9aa2a5b8e6ce7b18b3c832cec1d742848f115', 34],
['0xb40488bbde7c183c8ef9d6ba4a8682662d1d0b0d', 30],
['0x5e92f2482778bb2faa122f3de6137790469d78ff', 28],
['0x6d1e0084a6910a8803ab7c22483a1a2db3f1001a', 28],
['0x4f1b197f1068983d6a63ecb47b7ea6eae744c788', 26],
['0x2cd170d34740d2356c464f6bffec1d727a6c96e5', 25],
['0x630204233b046f477a4b0faec1d14e9f637e3773', 25],
['0xd4b2905ee116d13664840f67c9374b768d1297ed', 25],
['0xa6b6d854e4e5f2b36e51d1dff81cad56e5f286c1', 24],
['0x97db0e57b1c315a08cc889ed405adb100d7f137d', 23],
['0xde8476883a4b9acefcf736a8f97bce1f1fb54b37', 21],
['0xffe3385962b6bf54860f06dd35d5db3504bd1286', 20],
['0x05e43e56a6e9022a3bfc7e49308a7d77adb0317b', 19],
['0xa380dace2095adc258d2be066e2a60a9dbacf7ad', 19],
['0x1385a6aad6e6f7a396f7041b60807ce11306b4d1', 17],
['0x39129dcdc2f836653b6391edd991be4f4b675c8d', 17],
['0x5bfaad4a04ab0fab6d206c9ea1144da886d31f9a', 17],
['0xb8d86d6db117e21c27636034d3dd8859018daf9c', 16],
['0x9aabdbf1ec9c35c157ba456b292ce734c0ad6f19', 15],
['0x01a28d73010194bc8e503733928829312e73ab87', 14],
['0x19d269c688d34f3769fed1e2d1841420c67f96a4', 13],
['0x42a1ef5ffdaf134eb958814e443db9c244375c8f', 12],
['0x77c681753979400dc7310b770e88d9c823d1d808', 12],
['0x73b1b3410ac9c28216a0012aedc6926436518f50', 11],
['0x8703cb33299449766a8390fb98122ab6d0619c0c', 11],
['0xcdc7b771a0ef67519cfeba630451bfe1736ef344', 11],
['0x4533e03d983fae04741131c5f7cb35f1b32a1acd', 10],
['0x96126f8dc9c228b3579c4c2d3f2f7262066e1168', 8],
['0x03f1a715650814e31eeea113b3145981071dbfbc', 7],
['0x11da8f19361fc815074f1f86f4a9216984070b99', 7],
['0x3c935019cfe7b65d3de1bb326fdcd7a62fe9fe9f', 7],
['0xbb12c5453375332107b24914d169b6ac99bdea8b', 7],
['0x283a1dc0e8f85e14fd2cfd7046402ac701d2c800', 6],
['0x302d7125e4974ea52f85938cf2bf62844cbef510', 6],
['0x888d08a60678321a41e54c20fc0e9d5acdeeeeee', 6],
['0xa74b3afb52669c41ba36cc3742e10f4a55f75b8c', 6],
['0xc7450a7c19c366c283d21ba362b3eb7ccb8cb07e', 6],
['0xfc8084cf7e0f916f114f9bdd8a86ba2427efe976', 6],
['0x38dc04ec68ab54092d2a5ba01fcdd288f8a83107', 5],
['0x68aedee7dc9da33a1e7d32a6637361e409c40519', 5],
['0xb35b15694f5a9966db6c028636d4420c3113b398', 5],
['0xe99f8a84c3a5408926ce19caa63e7b0bbbddf0bd', 5],
['0x98bd996e969ab447d85414a8bec45e3e85fb0776', 4],
['0xf09f478c31c247602c019c5c1b700e766ec5fe10', 4],
['0x8288090f6016bd90dc234fc619baeaa6ba031ba6', 3],
['0x8de3c3891268502f77db7e876d727257dec0f852', 3],
['0xdfb12bf05af4fffbec2837ed890b48084c1f1c43', 3],
['0x00e81d0d81012e24a8c39aea69a9816c85409201', 2],
['0x043cf0414ad2991e910e464e4f3e80f14d7cf0b9', 2],
['0x391628a8da3d53fbff3a5312a698ce5830b2ad1f', 2],
['0x4976d2d3122c5d9392237efc1c1010bb2efddb81', 2],
['0x55a3aa5a7ecb1c5c738b097e67efe6a0c1be935a', 2],
['0x64755d51120b3dea2f3360ca08b739e5d3908153', 2],
['0x752d5a59d9cd3ed8af87e0c8939d5d19db168331', 2],
['0x78266b7341161ad0cbfac66c7fb234f4017bd18b', 2],
['0x7ad92e2b66c772ca9c56d4b59660ed537b28ab90', 2],
['0x839a4547fb3aef7c68bfc28248f7fd1de952b524', 2],
['0x87d9fdf0ef434c581cd4a410df6fd736349faa4b', 2],
['0x8cba8739bd4d5e797cefec47b5160cc4fa18e1af', 2],
['0x9d819695056bb1a372f9e715af5ec4c79595b67c', 2],
['0x9ee17ed9712e8db2cc92150db08ec63b0f3c11fe', 2],
['0xaa950d1cadd39935ecf1a11eb9f44955f21d3c90', 2],
['0xb1fc41cbad16cafdfc2ed196c7fe515dfb6a1577', 2],
['0xc0a1162c3ff721daa7e0141eb639cfb5765ea589', 2],
['0xf82fe7a94704598559828bfaa76393d47a81bf73', 2],
['0x01f109ac6e947715b3c3c506ee60d324d45edcd3', 1],
['0x11584d6aaebfdbf48cd5a11599bf40b5bc386837', 1],
['0x1363150a96ce368838bff7f7a4b399811ab1a7a3', 1],
['0x166af473ee7746cb6d54b2ceab59769d6ced859f', 1],
['0x2fbdbf6a9b35104b927c31c863f4872b841dd967', 1],
['0x2fe9811e6b3cceb5c14cca6523f10ffdf4288af6', 1],
['0x41bead0ecb415dff3e11fa21a99460746c313d7d', 1],
['0x44e434b0eb83534b697f9c77ef11fb981b637def', 1],
['0x492dcea5f6a71e74375b91ae474521a353d8348a', 1],
['0x540f3bf895ff2d10db9d9fdf5cd39c8313fd8d6c', 1],
['0x579c0c05b15e9268e33f00a49aec8b7cdb8c4f27', 1],
['0x632027d15cd8e6d97991771bf0d6a01b63b16c81', 1],
['0x677ecae194e874151ca8e0bd50d351a93888e149', 1],
['0x6c0d470d97ef1f230eef10a5c848afcc8261ed67', 1],
['0x745cd76273f5e1c78d0a2f1634d57a4bdf8cd00b', 1],
['0x78d07358af56736f660053a95aaf020d4df37654', 1],
['0xa1d76adef8bc9151490c0f66ecb0ffcd800c3e38', 1],
['0xa21e8b6757893577c27662ae5afe32e73c9dc4dd', 1],
['0xa8b63e1408e8e607d4cf48e6e3b14bb881b2010e', 1],
['0xb2ae7773e14d857d1202cfc2a6a5a2a3de1525f5', 1],
['0xb64c2e41ad313d25ce643a58b876fbe87427f96a', 1],
['0xd40dcf6788bc8d84835f6653124029bade1ca894', 1],
['0xe06d67e2cd5c51cbe0ec603a1e314039875e0ab2', 1],
['0xe7891ff5f0e6e39fbf49b523e2ca7bd22e7782b7', 1]

]